import { makeVar, useReactiveVar } from "@apollo/client";

// Whether the Career Tracks pages are being edited. Shared by every view of
// them (All Tracks, a department, a track, a person), so switching between
// views keeps whichever mode you were in. They open in Editing.
const isEditingRolesVar = makeVar(true);

const useRolesEditMode = () => {
  const isEditing = useReactiveVar(isEditingRolesVar);
  return { isEditing, setIsEditing: isEditingRolesVar };
};

export default useRolesEditMode;
